import { createRoutesMap } from '../app/route-map';

export const routingMap = createRoutesMap('');
